import IndustryTypeView from './View'

export default IndustryTypeView
